import { fl106 } from "./fl106";
import { fl107 } from "./fl107";
import { fl109 } from "./fl109";
import { fl110 } from "./fl110";
import { fl274 } from "./fl274";
import { fl111 } from "./fl111";
import { fl113 } from "./fl113";
import { fl114 } from "./fl114";

const distroToScriptTemplate = {
  "2.7.4": fl274,
  "3.1.0": fl106,
  "3.1.1": fl107,
  "3.2.1": fl109,
  "3.2.2": fl109,
  "3.2.3": fl109,
  "3.3.0": fl110,
  "3.3.2": fl111,
  "3.3.4": fl113,
  "3.3.5": fl114,
  "": {},
  null: {},
};

export const getScriptTemplatesByDistro = (distro) =>
  distroToScriptTemplate[distro];
